import React, { Component } from "react";
import { Image } from "react-bootstrap";
import Social from "../Social/Social";

import RCH_Footer_Logo from "../../_assets/FooterLogo.png";
import AxSLogo from "../../_assets/AxSLogo.png";

import "./style.css";

export default class Footer extends Component {
  render() {
    return (
      <div className={"footers " + this.props.footerStyle}>
        <footer className=" rch footer text-center p-4 p-sm-5 w-100 ">
          <div className="container-fluid">
            <Image className="rch-footer-logo" src={RCH_Footer_Logo} fluid />
            <p>
              <span className="footer-address">
                350 Terracina Blvd, Redlands, CA 92373 <br></br>
              </span>
            </p>
            <Social type="social-footer" />
          </div>
        </footer>
        <footer className="axs footer">
          <div className="container">
            <p className="text-center p-4"><Image className="rch-footer-logo" src={AxSLogo} fluid /></p>
          </div>
        </footer>
      </div>
    );
  }
}
